import {Alert, Button, Form, Input} from 'antd';
import {Formik} from 'formik';
import React from 'react';
import {Link} from 'react-router-dom';
import * as Yup from 'yup';

import {ClientData} from '../../../../types/src';
import {brandConfig} from '../../utils';
import {FormRow} from '../formComponents';

import './loginForm.scss';

interface LoginFormProps {
  client: ClientData;
  login: (email: string, password: string) => void;
  clearStatus: any;
}

const LoginSchema = Yup.object().shape({
  password: Yup.string().required('Required'),
  email: Yup.string().email('Invalid email format').required('Required'),
});

export const LoginForm: React.FC<LoginFormProps> = ({client, login, clearStatus}) => {
  const onSubmit = (form: any) => login(form.email, form.password);

  const {status, loading} = client;

  return (
    <Formik initialValues={{email: '', password: ''}} validationSchema={LoginSchema} onSubmit={onSubmit}>
      {({values, handleSubmit, setFieldValue, errors, touched}) => (
        <Form className="login-form" onFinish={handleSubmit} layout="vertical">
          <FormRow>
            <Form.Item
              label="Email"
              colon={false}
              validateStatus={errors.email && touched.email ? 'error' : ''}
              hasFeedback
              help={errors.email && touched.email ? errors?.email?.toString() : ''}
            >
              <Input
                type="text"
                placeholder="Enter your email"
                value={values.email}
                onChange={e => setFieldValue('email', e.target.value.replace(/\s/g, ''))}
              />
            </Form.Item>
          </FormRow>
          <FormRow>
            <Form.Item
              label="Password"
              colon={false}
              validateStatus={errors.password && touched.password ? 'error' : ''}
              hasFeedback
              help={errors.password && touched.password ? errors?.password?.toString() : ''}
            >
              <Input.Password
                autoComplete="off"
                placeholder="Enter your password"
                value={values.password}
                onChange={e => setFieldValue('password', e.target.value)}
              />
            </Form.Item>
          </FormRow>
          {!brandConfig.isAffiliate && (
            <div className="resetPassword" style={{marginTop: '10px', textDecoration: 'underline'}}>
              <Link style={{padding: 0}} to="/reset-password" onClick={clearStatus}>
                Forgot password?{' '}
              </Link>
            </div>
          )}
          {!!status.length && (
            <Alert message="Log in failed" description={status} type="error" style={{marginTop: '20px'}} />
          )}
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} style={{marginTop: '20px'}}>
              Log in
            </Button>
          </Form.Item>
        </Form>
      )}
    </Formik>
  );
};
